import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import {Router} from "@angular/router"
import { B2cService } from "../services/b2c/b2c.service";
@Injectable({
  providedIn: 'root'
})
export class AuthB2cGuard implements CanActivate {
  constructor(private router: Router,public b2cService:B2cService) {}
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    if (this.b2cService.isLoggedIn()) {
        return true;
    }else{
      this.router.navigate(['/connexion']);
      return false;
    }


  }

}
